// Organisation types — must match server/services/metrics/metrics.config.js
// ORG_TYPES. What each one means is in server/services/orgType.service.js.
export const ORG_TYPES = [
  { value: 'enterprise', label: 'Enterprise (customer)' },
  { value: 'explorer', label: 'Explorer (self-serve customer)' },
  { value: 'trial', label: 'Trial' },
  { value: 'internal', label: 'Internal (hidden from admin metrics, never expires)' },
  { value: 'test', label: 'Test (hidden from admin metrics)' },
];

// Never shown to the platform admin on the dashboards.
export const HIDDEN_FROM_ADMIN_TYPES = ['internal', 'test'];

export const isOrgType = (v) => ORG_TYPES.some((t) => t.value === v);

export const orgTypeLabel = (v) => (ORG_TYPES.find((t) => t.value === v) || {}).label || 'Not set';
